import React, {createContext, useContext, useEffect, useRef, useCallback, useState} from 'react';

import {closeEventSource, getEventSource} from '../../queries/sseClient';
import {BACKEND_URL, SSE_JOB_CHANNEL} from "@/constants/globalConstants";

import {SSEJobs} from '@/pages/custom-components/utils/sseUtils'
import {prev} from "stylis";

const url = BACKEND_URL + `/sse/jobsSSE`;

const TWENTY_FOUR_HOURS_MS = 7 * 24 * 60 * 60 * 1000;

const SSEProviderContext = createContext(undefined);

const SSEProv = ({ children }) => {
    const eventSourceRef = useRef(null);

    const [jobs, setJobs] = useState([])
    const [allMatches, setAllMatches] = useState([]) // NON SOLO STRINGHE, MA INTERI EVENTI DI JOBS
    /*I deletedJobs richiedono un dettaglio attento. NESSUNO DEVE ELIMINARE QUESTO COMMENTO
    * Praticamente l'assenza di una prova non è prova della sua assenza, quando si controllano i jobs nei vari componenti che usano l'SSE
    * effettivamente, per comprendere se c'è una rimozione di un job (così per catturare l'evento delete) allora si dice "se gli eventi non comprendono
    * l'attuale evento allora c'è stata una delete" ma è sbagliatissimo, dato che esiste questo intervallo che fa da garbage collector e, di conseguenza, rende
    * la delete NON l'unica opzione per non vedere più un job.
    * È necessario, quindi, avere un SET specifico (e limitato di dimensione poichè serve solo per runtime e non irrisorio e memory leak) di deletedJobs.
    * */
    const [deletedJobIds, setDeletedJobIds] = useState([])

    const listenerRef = useRef(null);

    // Pub-Sub subscribe function for update key moments cut count
    const subscribe = useCallback((listener) => {
        listenerRef.current = listener;

        // Cleanup per quando la tabella viene smontata
        return () => {
            if (listenerRef.current === listener) {
                listenerRef.current = null;
            }
        };
    }, []);

    const updateKeyMomentCountJob = useCallback((keyMomentEntity) => {
        if (listenerRef.current) {
            listenerRef.current({
                job_id: keyMomentEntity.entities.job_id,
                ev_id: keyMomentEntity.id,
                key_moment_count: keyMomentEntity.entities.count.key_moment_count
            });
        }
        /*setJobs((prev) => {
            const idx = prev.findIndex((j) => j.id === keyMomentEntity.entities.job_id);
            if (idx >= 0) {
                const copy = [...prev];
                if (copy[idx].type === SSEJobs.EXTRACTION) {
                    copy[idx] = { ...copy[idx], key_moment_count: keyMomentEntity.entities.count.key_moment_count };
                }
                return copy;
            }
            return prev;
        });*/
    }, []);

    const updateJobs = useCallback((job) => {
        setJobs((prev) => {
            const idx = prev.findIndex((j) => j.id === job.id)
            if (idx >= 0) {
                const copy = [...prev];
                copy[idx] = { ...copy[idx], ...job };
                return copy;
            }
            return [job, ...prev];
        });

        setAllMatches((prevState) => {
            let copyprev = [...prevState];

            if (job.events && Array.isArray(job.events)) {
                for (const e of job.events) {
                    const alreadyExists = prevState.some(existing => existing.id === e.id);
                    if (!alreadyExists && e.name !== undefined) {
                        copyprev = [e, ...copyprev];
                    }
                }
            }
            return copyprev
        });
    }, [])

    const deleteJob = useCallback((job) => {

        // Aggiungo l'ID al buffer circolare (massimo 20 elementi)
        setDeletedJobIds((prev) => {
            const newArray = [...prev, job.id];
            return newArray.slice(-20);
        });

        setJobs((prevJobs) => {
            const updatedJobs = prevJobs.filter((p) => p.id !== job.id);

            const allMatchesOfJobs = [];
            for (const j of updatedJobs) {
                if (j.events && Array.isArray(j.events)) {
                    for (const e of j.events) {
                        if (!allMatchesOfJobs.some((evento) => e.id === evento.id)) {
                            allMatchesOfJobs.push(e);
                        }
                    }
                }
            }

            setAllMatches(allMatchesOfJobs);

            return updatedJobs;
        });
    }, []);



    const openSSE = useCallback(() => {
        const token = localStorage.getItem('sessionToken');
        if (!token) {
            closeEventSource(SSE_JOB_CHANNEL);
            eventSourceRef.current = null;
            return;
        }

        const es = getEventSource(url, 'jobs');
        if (!es) return;

        eventSourceRef.current = es.eventSource;

        // INIT handler
        const handleInit = (event) => {
            const data = JSON.parse(event.data);

            if (data.type !== 'init') return;

            let copyprev = [];

            const modifiedPayload = data.payload.map(job => {
                if (job.events && Array.isArray(job.events)) {
                    for (const e of job.events) {
                        if (!copyprev.some(existingEvent => existingEvent.id === e.id)) {
                            copyprev.push(e);
                        }
                    }
                }
                return job;
            });

            setJobs(modifiedPayload)
            setAllMatches(copyprev);
        };

        // UPDATE handler
        const handleUpdate = async (event) => {
            const data = JSON.parse(event.data);

            // MESSAGGIO DI UPDATE DI UN JOB ON-DEMAND, PIÙ PRECISAMENTE PRODUCTION ON DEMAND
            if (
                data.type === '/update/job/production-on-demand'
            ) {
                const update = JSON.parse(data.payload);
                const updatedJob = update.entities.job;
                updatedJob.type = update.type;
                updateJobs(updatedJob);
            }
            // MESSAGGIO DI UPDATE DI UN JOB D'ELABORAZIONE DI INGESTION
            else if (data.type === `/update/job/${SSEJobs.INGESTION}`) {
                const update = JSON.parse(data.payload);
                const updatedJob = update.entities.job;
                updatedJob.type = update.type;
                updateJobs(updatedJob);
            }
            // MESSAGGIO DI UPDATE DI UN JOB D'ELABORAZIONE DI EXTRACTION
            else if (data.type === `/update/job/${SSEJobs.EXTRACTION}`) {
                const update = JSON.parse(data.payload);
                const updatedJob = update.entities.job;
                updatedJob.type = update.type;
                updateJobs(updatedJob);
            }
            // MESSAGGIO DI UPDATE DI UN JOB D'ELABORAZIONE DI PRODUZIONE
            else if (data.type === `/update/job/${SSEJobs.PRODUCTION}`) {
                const update = JSON.parse(data.payload);
                const updatedJob = update.entities.job;
                updatedJob.type = update.type;
                updateJobs(updatedJob);
            }
            // MESSAGGIO DI CREATE DI UN JOB DI PRODUZIONE ON DEMAND
            else if (data.type === `/create/job/${SSEJobs.PRODUCTION_ON_DEMAND}`) {
                const create = JSON.parse(data.payload);
                const createdJob = create.entities.job;
                createdJob.type = create.type;
                updateJobs(createdJob);
            }
            // MESSAGGIO DI CREATE DI UN JOB D'ELABORAZIONE DI INGESTION
            else if (data.type === `/create/job/${SSEJobs.INGESTION}`) {
                const create = JSON.parse(data.payload);
                const createdJob = create.entities.job;
                createdJob.type = create.type;
                updateJobs(createdJob);
            }
            // MESSAGGIO DI CREATE DI UN JOB D'ELABORAZIONE DI EXTRACTION
            else if (data.type === `/create/job/${SSEJobs.EXTRACTION}`) {
                const create = JSON.parse(data.payload);
                const createdJob = create.entities.job;
                createdJob.type = create.type;
                updateJobs(createdJob);
            }
            // MESSAGGIO DI CREATE DI UN JOB D'ELABORAZIONE DI PRODUCTION
            else if (data.type === `/create/job/${SSEJobs.PRODUCTION}`) {
                const create = JSON.parse(data.payload);
                const createdJob = create.entities.job;
                createdJob.type = create.type;
                updateJobs(createdJob);
            }
            // MESSAGGIO DI ELIMINAZIONE DI UN JOB DI PRODUCTION ON DEMAND
            else if (data.type === `/delete/job/${SSEJobs.PRODUCTION_ON_DEMAND}`) {
                const deleted = JSON.parse(data.payload);
                deleteJob(deleted);
            }
            // MESSAGGIO DI ELIMINAZIONE DI UN JOB DI INGESTION
            else if (data.type === `/delete/job/${SSEJobs.INGESTION}`) {
                const deleted = JSON.parse(data.payload);
                deleteJob(deleted);
            }
            // MESSAGGIO DI ELIMINAZIONE DI UN JOB DI EXTRACTION
            else if (data.type === `/delete/job/${SSEJobs.EXTRACTION}`) {
                const deleted = JSON.parse(data.payload);
                deleteJob(deleted);
            }
            // MESSAGGIO DI ELIMINAZIONE DI UN JOB DI PRODUCTION
            else if (data.type === `/delete/job/${SSEJobs.PRODUCTION}`) {
                const deleted = JSON.parse(data.payload);
                deleteJob(deleted);
            }
            else if (data.type === `/update/key_moment_count`) {
                const countEntity = JSON.parse(data.payload)
                updateKeyMomentCountJob(countEntity);
            }
        };

        const handleError = (err) => {
            console.error('Errore SSE:', err);
        };

        if (es.eventSource !== null) {
            es.eventSource.addEventListener('message', handleInit);
            es.eventSource.addEventListener('message', handleUpdate);
            es.eventSource.addEventListener('error', handleError);
        }

        return () => {
            if (es.eventSource !== null) {
                es.eventSource.removeEventListener('message', handleInit);
                es.eventSource.removeEventListener('message', handleUpdate);
                es.eventSource.removeEventListener('error', handleError);
            }
            closeEventSource(SSE_JOB_CHANNEL);
        };
    }, [updateJobs, deleteJob, updateKeyMomentCountJob])

    useEffect(() => {
        const interval = setInterval(() => {
            const now = Date.now();
            const keep = (j) => {
                const raw = j.updated_at;


                // se manca, tienilo (o decidilo tu)
                if (!raw) return true;

                // supporta numero (ms) o stringa ISO
                const ts =
                    typeof raw === "number" ? raw :
                        typeof raw === "string" ? Date.parse(raw) :
                            NaN;

                // se non parseabile, NON buttarlo via a caso
                if (!Number.isFinite(ts)) return true;


                return now - ts <TWENTY_FOUR_HOURS_MS

            };

            setJobs((prev) => prev.filter(keep));
            //setJobsCancelled((prev) => prev.filter(keep));
        }, 30 * 1000);

        return () => clearInterval(interval);
    }, []);


    useEffect(() => {
        const handleUnload = () => {
            closeEventSource(SSE_JOB_CHANNEL);
        };

        window.addEventListener('beforeunload', handleUnload);
        return () => {
            window.removeEventListener('beforeunload', handleUnload);
        };
    }, []);

    const closeSSE = () => {
        closeEventSource(SSE_JOB_CHANNEL)
        setJobs([])
        setAllMatches([])
    }

    return (
        <SSEProviderContext.Provider value={{ jobs, subscribe, allMatches, openSSE, deletedJobIds, closeSSE }}>
            {children}
        </SSEProviderContext.Provider>
    );
};

const useSSEProvider = () => {
    const context = useContext(SSEProviderContext);
    if (context === undefined) {
        throw new Error('SSEProvider must be used within a SSE provider');
    }
    return context;
};

export { SSEProv, useSSEProvider };
